import defineAbilityFor from 'src/utils/permissions';
import { useAuthContext } from './auth.context';
import { AbilityContext } from 'src/utils/can';

export default function AuthorizationContextProvider({
  children,
}: {
  children?: React.ReactNode;
}) {
  const { user } = useAuthContext();
  return (
    <AbilityContext.Provider value={defineAbilityFor(user)}>
      {children}
    </AbilityContext.Provider>
  );
}
